export function PosterSection() {
  return (
    <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-b from-white to-pink-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden transform hover:scale-[1.02] transition-transform duration-300">
            <img
              src="https://static.readdy.ai/image/c1ead532c50398fda057e46e940be938/8668977b95d23d5640478b0abee6f56d.jpeg"
              alt="제주블리여행사 소개 포스터 - 특별한 인연, 잊지 못할 여행"
              className="w-full h-auto"
              loading="lazy"
            />
          </div>
          
          <div className="mt-8 md:mt-12 text-center">
            <a
              href="tel:010-5685-7818"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white px-8 md:px-12 py-4 md:py-5 rounded-full text-base md:text-lg lg:text-xl font-bold shadow-lg hover:shadow-xl hover:from-teal-600 hover:to-teal-700 transform hover:scale-105 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-phone-fill text-xl md:text-2xl"></i>
              <span>지금 바로 문의하세요!</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}